export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    createMember: '/create-member',
    viewMember: '/view-member',
    referral: '/referral',
    claim: '/claim',
    batch: '/batch',
    worklist: '/worklist',
    rebilling: '/rebilling',
    serviceBus: '/service-bus',
    editAuctionEnd: '/edit-auction-end',
    clearTasks: '/clear-worklist-tasks',
    incidentManagement: '/incident-management',
    declareIncident: '/declare-incident',
    viewIncidents: '/view-incidents',
    incidentDetails: '/view-incidents/:incidentId',
} as const;

export const getIncidentDetailsPath = (incidentId: string) => `/view-incidents/${incidentId}`;
